// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__frame--g82Je {
  height: 100%;
  overflow: auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__topHeader--_yML3 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__topHeader--_yML3 .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__titleBox--oQbEf {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__topHeader--_yML3 .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__titleBox--oQbEf .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__title--VMlfu {
  color: rgba(0, 0, 0, 0.85);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__entityParams--oearX {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  column-gap: 24px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__tools--U98q_ {
  display: flex;
  justify-content: end;
  gap: 16px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__mainContent--EYidU {
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__mainContent--EYidU .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__spin--FZ4LM {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2Entity.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AADF;AAHA;EAOI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAVA;EAcM,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADN;AAMA;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;AAJF;AAOA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AALF;AAQA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AANF;AACA;EAOI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ","sourcesContent":[".frame {\n  height: 100%;\n  overflow: auto;\n  padding: 0 16px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.topHeader {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n\n  .titleBox {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    align-items: center;\n\n    .title {\n      color: rgba(0, 0, 0, 0.85);\n      font-family: Inter;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 120%;\n    }\n  }\n}\n\n.entityParams {\n  display: grid;\n  grid-template-columns: 1fr 1fr 2fr;\n  column-gap: 24px;\n}\n\n.tools {\n  display: flex;\n  justify-content: end;\n  gap: 16px;\n  align-items: center;\n}\n\n.mainContent {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  overflow: hidden;\n  .spin {\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__frame--g82Je`,
	"topHeader": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__topHeader--_yML3`,
	"titleBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__titleBox--oQbEf`,
	"title": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__title--VMlfu`,
	"entityParams": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__entityParams--oearX`,
	"tools": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__tools--U98q_`,
	"mainContent": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__mainContent--EYidU`,
	"spin": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Entity-module__spin--FZ4LM`
};
export default ___CSS_LOADER_EXPORT___;
